import { UPDATE_PROFILE } from '@storeOld/actions'
import { put } from 'redux-saga/effects'

import { type AccountActions, InternalAccountActions } from '../actions'

export function* update({ payload }: ReturnType<typeof AccountActions.update>) {
  yield put({ type: UPDATE_PROFILE, payload })

  yield put(InternalAccountActions.updateRequest(payload))
}
